import React from 'react'
import { input_class, label_class } from '../../functions/stateList'
import { notAllowEnterNumber } from '../../assets/scripts/GeneralFunctions'

export default function CarModalInput({
  title,
  type,
  isSubmit,
  name,
  value,
  inputHandler,
  error,
  maxLength,
}) {
  return (
    <label htmlFor={name} className={label_class}>
      {title}
      <input
        onKeyPress={(e) => notAllowEnterNumber(e, maxLength)}
        type={type}
        id={name}
        disabled={isSubmit}
        className={input_class}
        name={name}
        value={value}
        onChange={inputHandler}
      />
      {error?.[name] && <p className={'text-rose-500'}>{error?.[name]}</p>}
    </label>
  )
}
